export const TOPBAR = {
  themedHeight: "x6",
};
